export async function fetchTranslations(language) {
  try {
    return (await import(`../locales/messages_${language}.json`)).default;
  } catch {
    /* istanbul ignore next */
    return {};
  }
}
//# sourceMappingURL=fetchTranslations.js.map